import SelectSearch, { SelectSearchProps, ValueProps } from 'react-select-search';
import './DropdownSearch.css';
import { classList } from '../../helpers/classList';
import { FieldError } from '../FieldError';
import { FormLabel } from '../FormLabel';

// This resolves to the package's CommonJS build: its ESM one is broken, so every
// app's craco.config.js aliases the package to `dist/cjs` (the comment there has
// the details). Without that alias React throws "element type is invalid ...
// but got: object" the moment a dropdown renders.

export type DropdownSearchProps = Omit<SelectSearchProps, 'onBlur' | 'onFocus'> & {
  id?: string;
  name?: string;
  width?: string;
  label?: string;
  fuzzySearch?: boolean;
  className?: string;
  state?: 'normal' | 'valid' | 'error';
  required?: boolean;
  error?: string;
  emptyMessage?: string;
  placeholder?: string;
  onBlur?: (event: Event) => void;
  onFocus?: (event: Event) => void;
};

export const DropdownSearch = (props: DropdownSearchProps) => {
  const { id, error, width, onBlur, onFocus, ...cleanedProps } = props;

  const state = props.state && props.state != 'normal' ? props.state : undefined;

  const onBlurFunc = onBlur ?? (() => {});
  const onFocusFunc = onFocus ?? (() => {});

  return (
    <div style={{ width: width ?? '100%' }}>
      <FormLabel htmlFor={props.id} required={props.required}>
        {props.label}
      </FormLabel>
      <SelectSearch
        className={classList('select-search', props.className)}
        renderValue={(valueProps: ValueProps) => (
          <input
            id={id}
            {...(valueProps as any)}
            autoComplete='off'
            autoCorrect='off'
            spellCheck={false}
            className={classList('select-search__input', state ? `input-${state}` : undefined)}
          />
        )}
        search
        closeOnSelect
        onBlur={onBlurFunc}
        onFocus={onFocusFunc}
        {...cleanedProps}
      />
      {error && <FieldError>{error}</FieldError>}
    </div>
  );
};
